<ng-container *transloco="let t; read: 'basket'">
  @if (vm$ | async; as vm) {
    <div class="componentContainer">
      <section class="xs12col componentHeader">
        <h1>{{t('title')}}</h1>
      </section>
      @if (offlineBasketItems) {
        @if (offlineBasketItems.length != 0) {
          <section class="oneCol">
            <div class="xs12col">
              <div class="boxContainer offlineBasket">
                <div class="box">
                  <h3 class="offlineBasketWarning">{{t('offlineBasketWarning')}}</h3>
                  <app-offline-basket
                    (onReload)="reloadBasket()" [offline]="false">
                  </app-offline-basket>
                </div>
              </div>
            </div>
          </section>
        }
      }
      <section class="oneCol">
        <div class="xs12col">
          <div class="boxContainer">
            <div class="box">
              <app-basket-grid
                [data]="vm.basketItems"
                [loading]="loading"
                [request]="searchRequest$ | async"
                [skip]="vm.gridState.skip"
                [pageSize]="vm.gridState.pageSize"
                [isAdminView]="true"
                (onReload)="reloadBasket()">
              </app-basket-grid>
            </div>
          </div>
        </div>
      </section>
      <section class="oneCol">
        <div class="xs12col m6col">
          <div class="boxContainer">
            <div class="box">
              <h2>{{t('orderTitle')}}</h2>
              <form [formGroup]="orderForm" (submit)="onSendOrder()" id="basketOrderForm">
                <kendo-formfield>
                  <kendo-label
                    [for]="remarks"
                    [text]="t('remarks')"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="remarks"
                    #remarks
                  ></kendo-textbox>
                </kendo-formfield>
                <kendo-formfield>
                  <kendo-label
                    [for]="internalOrderNumber"
                    [text]="t('internalOrderNumber')"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="internalOrderNumber"
                    #internalOrderNumber
                    [required]="true"
                  ></kendo-textbox>
                  <kendo-formerror>{{t('isRequiredError')}}</kendo-formerror>
                </kendo-formfield>
                <button
                  [disabled]="orderForm.invalid || (vm.basketItems).data.length == 0 || orderForm.disabled || hasInactiveProducts"
                  kendoButton
                  (click)="onSendOrder()"
                  type="submit"
                  class="buttonPrimary">
                  {{t('sendOrder')}}
                </button>
                @if (hasInactiveProducts) {
                  <p class="inactive-warning">
                    {{t('basketContainsInactiveProducts')}}
                  </p>
                }
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  }
</ng-container>